<div class="retry-history-wrapper">

    <!-- Active Retry Section -->
    <div *ngIf="retrySpinner" fxLayoutAlign="center center" style="padding: 20px;">
        <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    
    <div *ngIf="!retrySpinner && !activeRetry" fxLayoutAlign="center center" style="padding: 20px; background-color: #f9f9f9; border-radius: 8px; margin-bottom: 30px;">
        <p style="margin: 0; color: #555;">No active retry currently assigned for this lead.</p>
    </div>

    <div *ngIf="!retrySpinner && activeRetry" class="retry-details-container" style="background-color: #f9f9f9; padding: 15px; border-radius: 8px; margin-bottom: 30px;">
        <h3 style="margin-bottom: 15px; color: #333;">Active Retry (Setting ID: {{activeRetry.retrySettingId}})</h3>
        <div fxLayout="row" fxLayoutGap="20px" style="margin-bottom: 20px;">
            <div><strong>Status:</strong> {{activeRetry.retryStatus}}</div>
            <div><strong>Cycle No:</strong> {{activeRetry.retryCycleNo}}</div>
            <div><strong>Current Retry #:</strong> {{activeRetry.currentRetryNumber}}</div>
            <div><strong>Next Retry Time:</strong> {{activeRetry.nextRetryDateTime | date:'medium'}}</div>
        </div>
        
        <h4 style="margin-bottom: 10px; color: #333;">Active Retry Steps</h4>
        <table class="table table-bordered table-striped" style="width: 100%; background: white;">
            <thead>
                <tr>
                    <th>Step #</th>
                    <th>Status</th>
                    <th>Scheduled Time</th>
                    <th>Actual Time</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let step of activeRetrySteps; let i = index">
                    <td>{{step.retryNumber}}</td>
                    <td>{{step.stepStatus}}</td>
                    <td>{{step.scheduledDateTime | date:'medium'}}</td>
                    <td>{{step.actualCallDateTime ? (step.actualCallDateTime | date:'medium') : '--'}}</td>
                </tr>
                <tr *ngIf="activeRetrySteps?.length === 0">
                    <td colspan="4" class="text-center" style="padding: 15px;">No steps found</td>
                </tr>
            </tbody>
        </table>
    </div>

    <hr style="margin: 30px 0; border: 0; border-top: 1px solid #ddd;" />

    <!-- History Section -->
    <h3 style="margin-bottom: 15px; color: #333;">Retry History</h3>

    <div fxLayout="row" fxLayoutAlign="end center" style="margin-bottom: 15px;">
        <input type="text" placeholder="Search by Status..." class="form-control" style="max-width: 250px;" #searchInput (keyup)="onFilterChange(searchInput.value)">
    </div>
    
    <div class="history-table-container mat-elevation-z1" style="background: white;">
        <div *ngIf="historySpinner" fxLayoutAlign="center center" style="padding: 20px;">
            <mat-spinner [diameter]="30"></mat-spinner>
        </div>
        
        <table mat-table [dataSource]="historyDataSource" matSort (matSortChange)="sortData($event)" style="width: 100%;" *ngIf="!historySpinner">
            
            <ng-container matColumnDef="retrySettingId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="a.retrySettingId"> Setting ID </th>
                <td mat-cell *matCellDef="let element"> {{element.retrySettingId}} </td>
            </ng-container>

            <ng-container matColumnDef="retryCycleNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="a.retryCycleNo"> Cycle No </th>
                <td mat-cell *matCellDef="let element"> {{element.retryCycleNo}} </td>
            </ng-container>

            <ng-container matColumnDef="currentRetryNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="a.currentRetryNumber"> Max Step Reached </th>
                <td mat-cell *matCellDef="let element"> {{element.currentRetryNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="retryStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="a.retryStatus"> Status </th>
                <td mat-cell *matCellDef="let element"> 
                    <span class="badge" [ngClass]="{'bg-success': element.retryStatus === 'COMPLETED', 'bg-warning': element.retryStatus === 'ACTIVE', 'bg-danger': element.retryStatus === 'CANCELLED'}">
                        {{element.retryStatus}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="a.createdDate"> Created Date </th>
                <td mat-cell *matCellDef="let element"> {{element.createdDate | date:'medium'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell text-center" colspan="5" style="padding: 20px;">No history data available for this lead.</td>
            </tr>
        </table>

        <mat-paginator [length]="pageList"
                       [pageIndex]="page"
                       [pageSize]="size"
                       [pageSizeOptions]="pageSizeOptions"
                       (page)="getUpdate($event)"
                       aria-label="Select page"
                       showFirstLastButtons>
        </mat-paginator>
    </div>
</div>
